import React, { useState } from "react";

const Search = ({ onSearch, placeholder }) => {
    const [search, setSearch] = useState("");
    const [searchState, setSearchState] = useState(true);

    const onInputChange = value => {
        setSearch(value);
        onSearch(value);
    };

    // const placeholderText = searchState ? "Search by " + placeholder.join(" , ") : "";
    return (
        <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={search}
            onChange={e => onInputChange(e.target.value)}
        />
    );
};

export default Search;
